import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function ContactScreen() {
    const { t } = useTranslation();

    return (
        <Container className='py-4'>
            <Row className='justify-content-center'>
                <Col md={7} lg={6}>
                    <h1 className='text-center mb-2' style={{ color: '#FF69B4', fontFamily: 'Georgia, serif' }}>
                        💌 {t('contactPage.title')}
                    </h1>
                    <p className='text-center text-muted mb-5'>
                        {t('contactPage.subtitle')}
                    </p>

                    <Card className='shadow-sm border-0 mb-4'>
                        <Card.Body className='p-4'>
                            <h5 className='mb-3'>📧 {t('contactPage.emailTitle')}</h5>
                            <p className='mb-1'>
                                <a href='mailto:contact@taletots.net' style={{ color: '#FF69B4', fontWeight: 500 }}>
                                    contact@taletots.net
                                </a>
                            </p>
                            <p className='text-muted small'>
                                {t('contactPage.emailNote')}
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className='shadow-sm border-0 mb-4'>
                        <Card.Body className='p-4'>
                            <h5 className='mb-3'>📱 {t('contactPage.socialTitle')}</h5>
                            <p className='text-muted mb-1'>
                                {t('contactPage.socialNote')}
                            </p>
                            <p className='mb-0' style={{ color: '#FF69B4', fontWeight: 500 }}>
                                Instagram • Facebook • LinkedIn
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className='shadow-sm border-0'>
                        <Card.Body className='p-4'>
                            <h5 className='mb-3'>❓ {t('contactPage.faqTitle')}</h5>
                            <p className='text-muted'>
                                {t('contactPage.faqNote')}
                            </p>
                            <Link to='/faq' style={{ color: '#FF69B4', fontWeight: 600, textDecoration: 'none' }}>
                                {t('nav.faq')} →
                            </Link>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default ContactScreen;
